import { Dispatch } from 'redux';
import { TaskId } from 'api/models';
import { Task, TaskAPI } from 'api/tasks';
import { saveTaskDetailSaga } from 'data/tasks/actions';
import { fetchTaskDetailError } from 'data/tasks/slice';
import { logger } from 'services';

export const debouncedFetchTaskSaga = async (
  [, projectId, taskId]: TaskId,
  dispatch: Dispatch,
  onFetchTaskSuccess?: (task: Task | undefined) => void,
  skipStoreUpdate?: boolean,
) => {
  try {
    const task = await TaskAPI.getTask(projectId, taskId);

    if (task) {
      if (onFetchTaskSuccess) {
        onFetchTaskSuccess(task);
      }
      if (skipStoreUpdate) {
        dispatch(saveTaskDetailSaga(task));
      }
    }
  } catch (error) {
    logger.error('getTaskByIdSaga failed', { error });
    dispatch(fetchTaskDetailError(taskId));
  }
};
